window.addEventListener("load", function() {
    let zxcvbn = require("zxcvbn");

    let strength = {
        0: "worst",
        1: "bad",
        2: "weak",
        3: "good",
        4: "strong"
    };

    let password = document.getElementById("password");
    let meter = document.getElementById("password-strength-meter");
    let alert = document.getElementById("password-strength-alert");
    let alertTitle = document.getElementById("password-strength-alert-title");
    let alertDesc = document.getElementById("password-strength-alert-desc");
    let passwordValidation = document.getElementById("password-validation");
    let btnSignup = document.getElementById("btn-signup");

    password !== null && password.addEventListener("input", function() {
        resetMeter();

        let val = password.value;
        let result = zxcvbn(val);
        let passwordStrength = strength[result.score];
        let meterLimit = result.score == 0 ? 1 : result.score;

        // Update the password strength meter
        for (let index = 0; index < meterLimit; index++) {
            if (passwordStrength === "weak" && val.length < 8) {
                meter.children[index].className = "bar bad";
                passwordNotValid();
                showAlertPasswordWeak();
            } else {
                if (
                    passwordStrength === "worst" ||
                    passwordStrength === "bad"
                ) {
                    passwordNotValid();
                    showAlertPasswordWorst();
                } else {
                    btnSignup.disabled = false;
                    clearAlert();
                    passwordIsValid();
                }

                meter.children[index].className = "bar " + passwordStrength;
            }
        }

        // Clear up
        if (val === "") {
            clearPasswordValidation();
            clearAlert();
            resetMeter();
        }
    });

    function resetMeter() {
        for (let index = 0; index < 4; index++) {
            meter.children[index].className = "bar";
        }
    }

    function passwordNotValid() {
        password.className = "form-control not-valid";
        passwordValidation.style.display = "inline-flex";
        passwordValidation.className = "not-valid";
        passwordValidation.innerHTML = '<i class="fa fa-minus-circle"></i>';
    }

    function passwordIsValid() {
        password.className = "form-control";
        passwordValidation.style.display = "inline-flex";
        passwordValidation.className = "valid"
        passwordValidation.innerHTML = '<i class="fa fa-check-circle"></i>';
    }

    function clearPasswordValidation() {
        password.className = "form-control";
        passwordValidation.style.display = "none";
    }

    function showAlertPasswordWorst() {
        if (alert != null) {
            alert.style.display = "flex";
            alertTitle.innerHTML = "Please choose a stronger password";
            alertDesc.innerHTML =
                "Try adding symbols or uncommon words. Don't reuse a password from another site.";
        }
    }

    function showAlertPasswordWeak() {
        if (alert != null) {
            alert.style.display = "flex";
            alertTitle.innerHTML = "Please choose a stronger password";
            alertDesc.innerHTML = "Your password must be at least 8 characters.";
        }
    }

    function clearAlert() {
        if (alert != null) {
            alert.style.display = "none";
        }
    }
});
